module.exports = __webpack_public_path__ + "static/media/icon-signature.cf6ef1d1.svg";